import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { wecomBind } from '@/api/auth';

export default function WecomCallbackPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { loginWithWecom } = useAuth();
  const [error, setError] = useState('');
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const code = params.get('code') ?? '';
    const state = params.get('state') ?? '';
    const saved = sessionStorage.getItem('wecom_state');
    sessionStorage.removeItem('wecom_state');

    if (!code) {
      setError('未获取到企业微信授权码');
      return;
    }
    if (saved && state !== saved) {
      setError('登录状态校验失败,请重试');
      return;
    }

    const intent = sessionStorage.getItem('wecom_intent');
    sessionStorage.removeItem('wecom_intent');

    if (intent === 'bind') {
      wecomBind(code)
        .then(() => navigate('/profile?wecom=bound', { replace: true }))
        .catch((err: unknown) => {
          const msg = err instanceof Error ? err.message : '企业微信绑定失败';
          setError(msg);
        });
      return;
    }

    loginWithWecom(code, state)
      .then(() => navigate('/', { replace: true }))
      .catch((err: unknown) => {
        const msg = err instanceof Error ? err.message : '企业微信登录失败';
        setError(msg);
      });
  }, [params, loginWithWecom, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background-100 px-4">
      <div className="text-center">
        {error ? (
          <>
            <i className="ri-error-warning-line text-3xl text-red-500"></i>
            <p className="mt-3 text-sm text-foreground-700">{error}</p>
            <button
              onClick={() => navigate('/login', { replace: true })}
              className="mt-4 h-10 px-6 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-sm font-medium cursor-pointer"
            >
              返回登录
            </button>
          </>
        ) : (
          <>
            <i className="ri-loader-4-line animate-spin text-3xl text-primary-500"></i>
            <p className="mt-3 text-sm text-foreground-500">正在通过企业微信登录...</p>
          </>
        )}
      </div>
    </div>
  );
}
